import { createSlice } from "@reduxjs/toolkit";

const counterpartySlice = createSlice({
    name: "counterparty",
    initialState: {
        counterpartyDetails: {},
        counterpartyError: null,
        counterpartyLoading: false,
    },
    reducers: {
        setCounterpartyDetails: (state, { payload }) => {
            state.counterpartyDetails = payload;
        },
        setCounterpartyError: (state, { payload }) => {
            state.counterpartyError = payload;
        },
        setCounterpartyLoading: (state, { payload }) => {
            state.counterpartyLoading = payload;
        },
    }
});

export const { setCounterpartyDetails, setCounterpartyError, setCounterpartyLoading } = counterpartySlice.actions;

export default counterpartySlice.reducer;